import { SourceOfIncomeService } from '@/modules/global-settings/miscellaneous/services/source-of-income-types.service';
import { make } from 'vuex-pathify';

const service = new SourceOfIncomeService();

export const state = {
  sourceOfIncomeTypes: []
};

export const mutations = {
  ...make.mutations(state)
};

export const actions = {
  // This action for legacy components remains unchanged
  async fetchSourceOfIncomeTypes({ commit }) {
    try {
      const { status, data } = await service.fetchSourceOfIncomeTypes();
      if (status == 200) {
        commit('SET_SOURCE_OF_INCOME_TYPES', data);
      }
      return status;
    } catch (error) {
      console.error("Error in fetchSourceOfIncomeTypes:", error);
      return error.response ? error.response.status : 500;
    }
  },

  async fetchPaginatedSourceOfIncomeTypes(_, params) {
    try {
      const { status, data } = await service.fetchPaginatedSourceOfIncomeTypes(params);
      
      if (status === 200) {
        return data;
      } else {
        return { data: [], total: 0 };
      }
    } catch (error) {
      console.error("Error fetching paginated source of income types:", error);
      return { data: [], total: 0 };
    }
  },

  async updateSourceOfIncomeType({ dispatch }, updates) {
    const { status } = await service.updateSourceOfIncomeTypes(updates);
    dispatch('fetchSourceOfIncomeTypes');
    return status;
  },

  async createSourceOfIncomeType({ dispatch }, incomeType) {
    const { status } = await service.createSourceOfIncomeType(incomeType);
    dispatch('fetchSourceOfIncomeTypes');
    return status;
  },

  async deleteSourceOfIncomeType({ dispatch }, incomeTypeId) {
    const { status } = await service.deleteSourceOfIncomeType(incomeTypeId);
    dispatch('fetchSourceOfIncomeTypes');
    return status;
  }
};

export const getters = {
  ...make.getters(state),
  activeSourceOfIncomeTypes(state) {
    return state.sourceOfIncomeTypes.filter((s) => s.status == true);
  }
};